import { render } from "./NavigationFullscreenColumn.vue?vue&type=template&id=5b026ef9"
import script from "./NavigationFullscreenColumn.vue?vue&type=script&lang=js"
export * from "./NavigationFullscreenColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__